// /src/toolkitServices/vendorApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const vendorApi = createApi({
  reducerPath: "vendorApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["Vendor"],
  endpoints: (builder) => ({
    addVendor: builder.mutation({
      query: (data) => ({
        url: "/vendors/create-vendor",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Vendor"],
    }),

    // LIST
    getAllVendors: builder.query({
      query: ({ page = 1, limit = 10, search = "", active } = {}) => {
        const params = { page, limit, q: search };
        if (typeof active === "boolean") params.active = active;
        return { url: "/vendors/get-all-vendors", params };
      },
      providesTags: ["Vendor"],
    }),

    // GET ONE
    getVendorById: builder.query({
      query: (id) => `/vendors/${id}`,
      providesTags: (_r, _e, id) => [{ type: "Vendor", id }],
    }),

    // UPDATE
    updateVendor: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/vendors/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Vendor"],
    }),

    // DELETE single
    deleteVendor: builder.mutation({
      query: (id) => ({
        url: `/vendors/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Vendor"],
    }),

    // ACTIVATE / DEACTIVATE single
    activateVendor: builder.mutation({
      query: (id) => ({
        url: `/vendors/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Vendor"],
    }),
    deactivateVendor: builder.mutation({
      query: (id) => ({
        url: `/vendors/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Vendor"],
    }),

    // 🔥 BULK
    bulkActivateVendors: builder.mutation({
      query: (ids) => ({
        url: `/vendors/bulk/activate`,
        method: "PATCH",
        body: { ids },
      }),
      invalidatesTags: ["Vendor"],
    }),
    bulkDeactivateVendors: builder.mutation({
      query: (ids) => ({
        url: `/vendors/bulk/deactivate`,
        method: "PATCH",
        body: { ids },
      }),
      invalidatesTags: ["Vendor"],
    }),
    bulkDeleteVendors: builder.mutation({
      query: (ids) => ({
        url: `/vendors/bulk/delete`,
        method: "POST",
        body: { ids },
      }),
      invalidatesTags: ["Vendor"],
    }),
  }),
});

export const {
  useAddVendorMutation,
  useGetAllVendorsQuery,
  useGetVendorByIdQuery,
  useUpdateVendorMutation,
  useDeleteVendorMutation,
  useActivateVendorMutation,
  useDeactivateVendorMutation,
  useBulkActivateVendorsMutation,
  useBulkDeactivateVendorsMutation,
  useBulkDeleteVendorsMutation,
} = vendorApi;

export default vendorApi;
